// Display-only accounting over the Offices API contract. Never a Capacity input.
export const CAPACITY_STATUS_DEFINITION = "Capacity status uses assigned today vs usable seats this month; forecast demand starts next month (see Capacity tab)";
export const marketAssignedToday = m => m.assignmentToday ? m.assignmentToday.assigned?.value : m.totalHeadcount;
export const marketInstalledToday = m => m.assignmentToday ? m.assignmentToday.seats?.value : m.totalSeats;

export function officeAssignedToday(office) {
  if (office.inventoryRow) return office.inventoryRow.latestHeadcount?.totalCount ?? null;
  if (Object.hasOwn(office, "assignedToday")) return office.assignedToday;
  return office.latestHeadcount?.totalCount ?? office.headcount ?? null;
}

export function officeSeatsToday(office) {
  if (office.inventoryRow) return office.inventoryRow.installedCapacity ?? null;
  if (Object.hasOwn(office, "assignmentSeats")) return office.assignmentSeats;
  return office.installedCapacity ?? null;
}

export function knownTotal(offices, valueOf) {
  let subtotal = 0;
  let known = 0;
  const missing = [];
  for (const office of offices) {
    const value = valueOf(office);
    if (value != null && value !== "" && Number.isFinite(Number(value))) {
      subtotal += Number(value);
      known += 1;
    } else {
      missing.push({ id: office.id ?? office.locationId,
        name: office.locationAlias || office.name || office.locationId || office.id });
    }
  }
  return { value: known ? subtotal : null, known, total: offices.length, missing };
}

export function marketAssignment(inventory, marketId) {
  if (!inventory || inventory.loading) return { status: "loading" };
  if (inventory.error) return { status: "error", error: inventory.error };
  const offices = inventory.locations.filter(o => o.marketId === marketId
    && !o.deletedAt && ["operational", "dormant"].includes(o.stage));
  return { status: offices.length ? "ok" : "excluded", offices,
    assigned: knownTotal(offices, o => o.latestHeadcount?.totalCount),
    seats: knownTotal(offices, o => o.displayInstalledCapacity ?? o.installedCapacity) };
}

export function coverageText(coverage, measure) {
  return coverage?.missing?.length
    ? `Partial ${measure}: missing data for ${coverage.missing.map(o => `${o.name}${o.id && o.name !== o.id ? ` (${o.id})` : ""}`).join(", ")}. ${coverage.known} of ${coverage.total} offices known.`
    : "";
}
